import React from 'react'
import TextField from '@material-ui/core/TextField'
import { useForm, Controller } from 'react-hook-form'
import { EMAIL_REGEX } from '../../Constants'
import { SkywatchDialog } from '../PopUps/SkywatchDialog'
import FlexView from 'react-flexview/lib'
import { ElevatedCircle } from '../Core/ElevatedCircle'
import policymanagementApi from '../../api/policymanagement.api'
import { addDays, awaitWithLoading } from '../../services/utils'
import {
  EventEmitterService,
  EventKey,
} from '../../services/EventEmitterService'
import {
  PolicyManagementContextStore,
  ACTIONS,
} from '../../context/PolicyManagementContext'
import { Action } from '../../models/Action'
import AssignmentIcon from '@material-ui/icons/Assignment'
import { ActiveInsuranceModel } from '../../models/insurance-models/ActiveInsuranceModel'
import {
  RadioGroup,
  Radio,
  FormControlLabel,
  Select,
  MenuItem,
  Grid,
  IconButton,
  InputAdornment,
} from '@material-ui/core'
import policmanagementImpersonationApi from '../../api/policmanagement.impersonation.api'
import { BlueGrayBox } from '../Core/BlueGrayBox'
import { DatePicker } from '@material-ui/pickers'
import {
  FirebaseService,
  FirebaseConfigKey,
} from '../../services/FirebaseService'
import EventIcon from '@material-ui/icons/Event'
import NewFillButton from '../Core/NewFillButton'
export const ApproveBorderauxDataPopup = ({
  openApprove,
  onClose,
  onApprove,
  borderauxData,
}) => {
  const { register, errors, getValues, triggerValidation, control } = useForm()
  const context = React.useContext(PolicyManagementContextStore)
  return (
    <SkywatchDialog
      open={openApprove}
      maxWidth={'xs'}
      closeDialog={() => onClose()}>
      <div>
        <div className="textcenter">
          You are about to send Global a Borderaux
          <br />
          <div>Subscription</div>
          Total Premium:{' '}
          {FirebaseService.getValue(FirebaseConfigKey.CURRENCY_SYMBOL)}
          {borderauxData.total_premium}
          <br />
          Total Remittance:{' '}
          {FirebaseService.getValue(FirebaseConfigKey.CURRENCY_SYMBOL)}
          {borderauxData.total_remittance}
          <br />
          Total Surcharge:{' '}
          {FirebaseService.getValue(FirebaseConfigKey.CURRENCY_SYMBOL)}
          {borderauxData.total_surcharge}
          <br />
          By clicking 'Approve' the Borderaux will be sent
        </div>
        <NewFillButton onClick={onApprove}>Approve</NewFillButton>
      </div>
    </SkywatchDialog>
  )
}
